import React, { Fragment } from 'react'
import styled from 'styled-components'
import Colors from '../../../constants/Colors'
import { IconBin } from '../../../constants/icons'

const FoundPrize = ({ foundPrize, handleClickRemoveSomeLottery }) => {

  const handleClickCopyAllPrize = () => {
    let text = ''

    Object.keys(foundPrize).forEach((key) => {
      const prizes = foundPrize[key]

      prizes.forEach((prize) => {
        text += prize.lotteryId + '\n'
      })
    })

    navigator.clipboard.writeText(text)
  }

  const handleClickCopySomePrize = (prizeName) => {
    let text = ''
    const prizes = foundPrize[prizeName]

    prizes.forEach((prize) => {
      text += prize.lotteryId + '\n'
    })

    navigator.clipboard.writeText(text)
  }

  return (
    <FoundPrizeContent>
      <Button color={Colors.GREEN} onClick={handleClickCopyAllPrize}>คัดลอกตัวเลขที่ถูกรางวัลทั้งหมด</Button>
      {Object.keys(foundPrize).map((prizeName) => {
        const prizes = foundPrize[prizeName]

        return (
          <Fragment key={prizeName}>
            <div className="prize-header">
              <div className="prize-title">{prizeName} ทั้งหมด {prizes.length} ใบ</div>
              <button className="prize-copy-button" onClick={() => handleClickCopySomePrize(prizeName)}>คัดลอก {prizeName} ทั้งหมด</button>
            </div>
            <div className="prize-content">
              {prizes.map((prize) => {
                return (
                  <div key={prize.lotteryId} className="prize-box" >
                    <div className="prize-overlay-color" onClick={() => handleClickRemoveSomeLottery(prize.index)} >
                      <span className="prize-icon-box">
                        <IconBin fill={Colors.WHITE} />
                      </span>
                      <div className="prize-overlay" />
                      <img src={prize.url} alt="found prize" className="prize-image" />
                    </div>
                    <div className="prize-id">
                      {prize.lotteryId}
                    </div>
                  </div>
                )
              })}
            </div>
          </Fragment>
        )
      })}
    </FoundPrizeContent>
  )
}

export default FoundPrize

const FoundPrizeContent = styled.div`
  .prize-header {
    display: flex;
    justify-content: space-between;
    margin: 1em 0 1em 0;
    
    .prize-title {
      font-family: Prompt-SemiBold;
      line-height: 24px;
      font-size: 16px;
      flex: 1;
    }

    .prize-copy-button {
      flex: 1;
      font-size: 1em;
      font-weight: bold;
      padding: 0.25em 1em;
      border-radius: 3px;
      color: ${Colors.WHITE};
      border: 2px solid ${Colors.GREEN};
      background-color: ${Colors.GREEN};

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }

  .prize-content {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;

    .prize-box {
      width: 24%;
      height: 24%;
      margin-bottom: 24px;
      text-align: center;
      border-radius: 8px;
      border: 1px solid ${Colors.LIGHT_GREY2};
      background-color: ${Colors.SOFT_WHITE};

      .prize-overlay-color {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .prize-icon-box {
          position: absolute;
          display: none;
          z-index: 1;
        }

        .prize-overlay {
          display: none;
          border-radius: 8px;
          opacity: 0.5;
          width: 100%;
          height: 100%;
          position: absolute;
          background-color: ${Colors.SUPER_BLACK};
        }

        .prize-image {
          width: 100%;
          border-radius: 8px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }

        &:hover {
          cursor: pointer;

          .prize-overlay {
            display: block;
          }
          .prize-icon-box {
            display: block;
          }
        }
      }
    }

    .prize-id {
      box-sizing: border-box;
      font-size: 16px;
      font-weight: normal;
      width: 100%;
      margin: 4px 0;
      text-align: center;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      color: ${Colors.DARK_GREY};
    }
  }
`

const Button = styled.button`
  width: 100%;
  font-size: 1em;
  font-weight: bold;
  padding: 0.25em 1em;
  border-radius: 3px;
  color: ${Colors.WHITE};
  border: 2px solid ${({ color }) => color};
  background-color: ${({ color }) => color};

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  
  :disabled {
    background: #fbfbfb;
    border: solid 1px ${Colors.LIGHT_GREY};
    color: ${Colors.LIGHT_GREY2};
    fill: ${Colors.LIGHT_GREY2};
  }
`
